var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUserBlocked = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "24-human/default"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4C9.2 4 7 6.2 7 9C7 11.8 9.2 14 12 14C14.8 14 17 11.8 17 9C17 6.2 14.8 4 12 4ZM8.84003 9C8.84003 10.7775 10.2225 12.16 12 12.16C13.7775 12.16 15.16 10.7775 15.16 9C15.16 7.2225 13.7775 5.84 12 5.84C10.2225 5.84 8.84003 7.2225 8.84003 9Z",
    fill: "#19252E",
    fillOpacity: 0.56
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 16.75C16.3 15.55 14.35 15 12 15C9.65 15 7.7 15.55 6 16.75C4.6 17.75 4 18.85 4 20H6C6 19.4 6.4 18.8 7.1 18.3C8.45 17.4 10.1 16.95 12 16.95C13.9 16.95 15.55 17.4 16.9 18.3C17.6 18.8 18 19.4 18 20H20C20 18.85 19.4 17.75 18 16.75Z",
    fill: "#19252E",
    fillOpacity: 0.56
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUserBlocked);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/user_blocked.0f8e1d0fcbb9d3e3c9580539e0577bc3.svg";